import { render, staticRenderFns } from "./SuperAdminHeader.vue?vue&type=template&id=40756295"
import script from "./SuperAdminHeader.vue?vue&type=script&lang=js"
export * from "./SuperAdminHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40756295')) {
      api.createRecord('40756295', component.options)
    } else {
      api.reload('40756295', component.options)
    }
    module.hot.accept("./SuperAdminHeader.vue?vue&type=template&id=40756295", function () {
      api.rerender('40756295', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/SuperAdminHeader.vue"
export default component.exports